import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ComissaoJulgadoraService } from '../comissao-julgadora-service'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'inscricoes-transferir-presidencia-dialog',
  templateUrl: './transferir-presidencia-dialog.component.html',
  styleUrls: ['./transferir-presidencia-dialog.component.scss'],
})
export class TransferirPresidenciaDialogComponent implements OnInit {
  private destroyRef = inject(DestroyRef)

  form: FormGroup
  titulares: any[] = []
  carregando = true
  enviando = false

  constructor(
    public dialogRef: MatDialogRef<TransferirPresidenciaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comissaoJulgadoraId: number },
    private fb: FormBuilder,
    private comissaoJulgadoraService: ComissaoJulgadoraService,
    private unespCoreMessageService: UnespCoreMessageService
  ) {
    this.form = this.fb.group({
      novoPresidenteId: [null, Validators.required],
    })
  }

  ngOnInit(): void {
    this.comissaoJulgadoraService.listarTitularesTransferencia(this.data.comissaoJulgadoraId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (titulares) => {
        this.titulares = titulares
        this.carregando = false
      },
      error: () => {
        this.carregando = false
        this.unespCoreMessageService.showMessageError('Erro ao carregar titulares')
      },
    })
  }

  cancelar(): void {
    this.dialogRef.close()
  }

  confirmar(): void {
    if (this.form.valid && !this.enviando) {
      this.enviando = true
      this.comissaoJulgadoraService
        .transferirPresidencia(this.data.comissaoJulgadoraId, this.form.value.novoPresidenteId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.dialogRef.close(true)
            this.unespCoreMessageService.showMessageSuccess('Presidência transferida com sucesso!')
          },
          error: (err) => {
            console.error('Erro ao transferir presidência:', err)
            this.enviando = false
            this.unespCoreMessageService.showMessageError(
              'Erro ao transferir presidência: ' + (err.error?.message || 'Erro desconhecido')
            )
          },
        })
    }
  }
}
